const numberWithCommas = (x) => {
    var parts = x.toString().split(".");
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return parts.join(".");
}

export const nFormatter = (num) => {
    num = Number(num);
    // if (num >= 1000000000) {
    //     return (num / 1000000000).toFixed(1).replace(/\.0$/, '') + 'G';
    // }
    // if (num >= 1000000) {
    //     return (num / 1000000).toFixed(1).replace(/\.0$/, '') + 'M';
    // }
    if (num >= 1000000) {
        // return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        const number = (Math.floor(num / 100000) / 10);
        return numberWithCommas(number) + 'M';
    }
    if (num >= 1000) {
        // return (num / 1000).toFixed(1).replace(/\.0$/, '') + 'K';
        const number = Math.floor(num/1000);
        return numberWithCommas(number) + 'K';
    }
    return num;
}

export const countFormatter = (num) => {
    num = Number(num);
    if (num >= 1000000) {
        const number = (num/1000000).toFixed(1) * 1;
        return numberWithCommas(number) + 'M';
    }
    if (num >= 100000) {
        const number = Math.round(num/1000);
        return numberWithCommas(number) + 'K';
    }
    if (num >= 1000 && num < 100000) {
        const number = (num/1000).toFixed(1) * 1;
        return numberWithCommas(number) + 'K';
    }
    return num;
}

export const stepFormatter = (num) => {
    num = Number(num);
    if (num >= 1000) {
        const roundumber = Math.round(num/1000);
        const number = Math.round(roundumber / 5) * 5
        return numberWithCommas(number) + 'K';
    }
    else {
        return Math.round(num);
    }
}

export const labelFormater = (num) => {
    // let labelNumber = '';
    // if (num >= 1000000) {
    //   let numberValue = (num / 1000000).toFixed(1) * 1;
    //   labelNumber = (Math.floor(numberValue * 2) / 2) + 'M'
    // } 
    // else if (num >= 100000) {
    //   let numberValue = (num / 1000) * 1;
    //   labelNumber = (Math.round(numberValue / 100) * 100) + 'K'
    // } 
    // else if (num >= 1000) {
    //     let numberValue = (num / 1000) * 1;
    //     labelNumber = (Math.round(numberValue / 10) * 10) + 'K'
    // } 
    // return labelNumber;
    num = Number(num);
    if (num >= 1000000) {
        const number = (num/1000000).toFixed(1) * 1;
        return numberWithCommas(number) + 'M';
    }
    if (num >= 1000) {
        const number = Math.round(num/1000);
        return numberWithCommas(number) + 'K';
    }
    return num;
}

export const capitalizeWords = (str) => {
    return str
      .toLowerCase()
      .split(' ')
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(' ');
};

export const trimCharacters = (str) => {
    if (str.length > 27) {
        return str.substring(0, 27) + "...";
    }
    else {
        return str
    }
}

const rFormatter = (num) => {
    return num.toLocaleString();
}

export default nFormatter;

